<template>
  <div class="page flex-col">
    <div class="box_1 flex-col">
      <div class="text-wrapper_1 flex-col">
        <span class="text_7">新闻报道</span>
        <span class="text_8">了解华为云最新动态</span>
      </div>
      <div class="text-wrapper_2">
        <span class="text_9">了解华为云</span>
        <span class="text_10">&gt;&nbsp;</span>
        <span class="text_11">资讯中心</span>
        <span class="text_12">&gt;</span>
        <span class="text_13">&nbsp;华为云正成为拉美多云首选，携手企业即刻领</span>
      </div>
    </div>
    <div class="box_3 flex-col">
      <span class="text_14">夜间经济添活力&nbsp;AI数字人服务中心守护商场“不打烊”服务</span>
      <div class="text-wrapper_3 flex-row justify-between">
        <span class="text_15">人工智能商城平台</span>
        <span class="text_16">人工智能商城平台</span>
        <span class="text_17">2025-12-19</span>
        <span class="text_18">阅读&nbsp;8545</span>
      </div>
      <div class="box_4 flex-col"></div>
      <span class="paragraph_1">
        随着夜间经济持续升温，商场晚间、深夜时段客流不断攀升，传统人工客服下班离场后，服务断层问题凸显。近日，成都多家主打夜间消费的商场、夜市综合体，全面部署AI数字人服务中心，24小时不间断值守，填补夜间服务空白，为夜间经济保驾护航，成为商场夜间运营的“智能管家”。&nbsp;成都锦江区某潮流商场，将营业时间延长至23点，夜间客流占全天客流近4成，多为年轻消费群体，主打餐饮、娱乐、休闲消费。此前，晚间20点后人工客服陆续下班，顾客遇到停车缴费、店铺寻找、应急求助等问题，往往无人解答，投诉量居高不下。自AI数字人服务中心上岗后，全天候值守响应，无论是晚间就餐指引、KTV位置查询，还是深夜停车指引、应急通道咨询，都能快速精准解答，全程无需人工干预。&nbsp;“我们晚上经常来逛商场吃饭、看电影，以前晚了找个停车场、问个路都没人管，现在有数字人随时问，特别方便，再也不用摸黑找地方了。”经常夜间逛商场的年轻消费者王先生说道。商场运营方数据显示，部署数字人服务中心后，夜间时段咨询投诉量下降70%，顾客停留时长延长15%，夜间消费转化率小幅提升，有效激活了夜间消费潜力。&nbsp;据了解，该商场数字人服务中心还具备夜间应急联动功能，遇到顾客突发需求、紧急情况，可一键转接人工值班客服，同步推送位置信息，实现智能响应与人工应急无缝衔接。同时，数字人自动记录夜间顾客咨询热点、消费偏好，为商场优化夜间业态布局、活动策划提供数据支撑，助力商场精准运营夜间经济。&nbsp;成都市商业经济学会相关专家表示，夜间经济是实体商业新的增长极，服务配套是关键，AI数字人服务中心完美解决了夜间人力不足、服务断层的行业痛点，既保障了服务连续性，又控制了运营成本，是夜间经济提质升级的重要配套设施。目前，成都多条特色商业街区、夜间夜市也陆续引入数字人服务终端，打造全天候智慧服务体系，助力夜间经济高质量发展。
        <br />
        华为拉美地区部总裁周丹金发表主题演讲，表示华为在拉美的承诺是长期且坚定的。截至2025年，华为已设立超过20个办公室，拥有4400多名员工，其中本地化率超过70%，间接支持了超过10万个工作岗位。华为不仅是多个国家的最佳雇主，更通过运营商业务服务了超过50%的拉美人口，在企业、数字能源、终端等领域与数千家伙伴和客户深度合作。华为是扎根于此的数字基础设施和智能终端提供商，致力于成为拉美数字化和绿色转型最可靠的合作伙伴。华为拉美地区部总裁周丹金发表主题演讲，表示华为在拉美的承诺是长期且坚定的。截至2025年，华为已设立超过20个办公室，拥有4400多名员工，其中本地化率超过70%，间接支持了超过10万个工作岗位。华为不仅是多个国家的最佳雇主，更通过运营商业务服务了超过50%的拉美人口，在企业、数字能源、终端等领域与数千家伙伴和客户深度合作。华为是扎根于此的数字基础设施和智能终端提供商，致力于成为拉美数字化和绿色转型最可靠的合作伙伴。华为拉美地区部总裁周丹金发表主题演讲，表示华为在拉美的承诺是长期且坚定的。截至2025年，华为已设立超过20个办公室，拥有4400多名员工，其中本地化率超过70%，间接支持了超过10万个工作岗位。华为不仅是多个国家的最佳雇主，更通过运营商业务服务了超过50%的拉美人口，在企业、数字能源、终端等领域与数千家伙伴和客户深度合作。华为是扎根于此的数字基础设施和智能终端提供商，致力于成为拉美数字化和绿色转型最可靠的合作伙伴。华为拉美地区部总裁周丹金发表主题演讲，表示华为在拉美的承诺是长期且坚定的。截至2025年，华为已设立超过20个办公室，拥有4400多名员工，其中本地化率超过70%，间接支持了超过10万个工作岗位。华为不仅是多个国家的最佳雇主，更通过运营商业务服务了超过50%的拉美人口，在企业、数字能源、终端等领域与数千家伙伴和客户深度合作。华为是扎根于此的数字基础设施和智能终端提供商，致力于成为拉美数字化和绿色转型最可靠的合作伙伴。华为拉美地区部总裁周丹金发表主题演讲，表示华为在拉美的承诺是长期且坚定的。截至2025年，华为已设立超过20个办公室，拥有4400多名员工，其中本地化率超过70%，间接支持了超过10万个工作岗位。华为不仅是多个国家的最佳雇主，更通过运营商业务服务了超过50%的拉美人口，在企业、数字能源、终端等领域与数千家伙伴和客户深度合作。华为是扎根于此的数字基础设施和智能终端提供商，致力于成为拉美数字化和绿色转型最可靠的合作伙伴。
      </span>
      <img
        class="image_2"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng116f5a496415f2f0b70d4b95848202e5c392ec20477d5338ff1fc5b34499f5ea.png"
      />
      <span class="text_19">下一篇:&nbsp;用AI解行业难题，华为云峰会在MWC&nbsp;2026成功举行</span>
    </div>
    <SiteFooter />
  </div>
</template>
<script>
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  components: { SiteFooter },
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="less" src="./assets/index.less" />